import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import type { DynamicOptionsLoadingProps } from 'next/dist/shared/lib/dynamic';
export function LoadingComponent(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <div>{props.error ? <div>Error: {props.error.message}</div> : props.isLoading ? <div>Loading component...</div> : <div>In an odd state: {JSON.stringify(props)}</div>}</div>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}